type ItemId = string;

export function mergeById<T>(
    existingItems: T[],
    incomingItems: T[],
    getId: (item: T) => ItemId
): T[] {
    const mergedItems = new Map<ItemId, T>();

    existingItems.forEach((item) => mergedItems.set(getId(item), item));
    incomingItems.forEach((item) => mergedItems.set(getId(item), item));

    return Array.from(mergedItems.values());
}
